export function mergeMaterialFluxes(initialArray, mergeConfig) {
  const newArray = [];

  mergeConfig.forEach((merge) => {
    const { referenceName } = merge;

    const matchingObjs = initialArray.filter(
      (item) => item.cls === referenceName,
    );

    if (matchingObjs.length > 0) {
      matchingObjs.forEach((matchingObj) => {
        const newObj = {
          cls: referenceName,
          referenceName,
          sizeRange: matchingObj.sizeRange || "total",
          surface: matchingObj.surface,
          count: matchingObj.count,
          volumeObject: matchingObj.volumeObject,
          massObject: matchingObj.massObject,
          recoverable: matchingObj.recoverable,
          parentCategory: matchingObj.parentCategory,
          finesMass: matchingObj.finesMass,
          finesProportion: matchingObj.finesProportion,
          density: matchingObj.density,
          rep: matchingObj.rep,
          isWeight: matchingObj.isWeight,
        };

        if (newObj.surface > 0) {
          newArray.push(newObj);
        }
      });
    }
  });
  return newArray;
}
